import * as scene from '../scene.js';
import * as loader from '../loader.js';
import * as audio from '../audio.js';
import * as player from '../player.js';
import { Tween } from '../tweens.js';
import * as dom from '../dom.js';

export {
    init,
}

const POIs = [
    {
        name: 'stonehenge-center',
        position: { x: 0, y: 0, z: 0 },
        color: 'hsl(0, 0%, 20%)',
        radius: 20,
        style: 'idle',
        symbolic: false,
        collision: {
            radius: 1,
        },
        onEnter() {
            if (this.style === 'idle') return;

            audio.fadeOutAll(); // TODO: This will not stop Grudge's whistles and will prevent restarting the game

            audio.buffers.play('ding-final', {
                gain: 0,
            });

            player.config.controllable = false;
            new Tween(player.position, this.position, 2, 'easeOutQuad');
            new Tween(player.direction, 0, 2, 'easeOutQuad', (v) => {
                player.setDirection(v);
            });

            setTimeout(() => {
                audio.buffers.play('labyrinthe-des-echos', {
                    gain: 0,
                });
            }, 2000);

            setTimeout(() => {
                dom.showMessage(`
                    Cet épisode expérience a été créée dans les locaux d’INIZIO,<br>
                    à Vevey (CH) du 11 au 15 mars 2024 avec la participation de :<br>
                    <br>
                    Brendan, Charline, Dragos, Daniel, Daniel,<br>
                    Eline, Justin, Jonas, Laura, Leo,<br>
                    Loïc, Mateo, Mauro, Nicolas, Purdey,<br>
                    Stefanie, et Willow<br>
                    <br>
                    <a href="https://low-project.ch/">low-project.ch</a><br>
                    <a href="https://inizio-vd.ch/">inizio-vd.ch</a>
                `.trim(), 'Fin');
            }, 10000);
        }
    },
    {
        name: 'stonehenge-triangle-1',
        position: { x: 0, y: -2, z: 1.8 },
        color: 'hsl(0, 100%, 50%)',
        type: 'triangle',
        radius: 7.5,
        symbolic: false,
        style: 'idle',
        rotation: 180,
        collision: {
            radius: 0.5,
        },
        onEnter() {
            if (this.style === 'active') audio.buffers.play('Flash_maraisOut', {
                gain: 0,
            });
        }
    },
    {
        name: 'stonehenge-triangle-2',
        position: { x: 1.41, y: -1.41, z: 1.8 },
        color: 'hsl(45, 100%, 50%)',
        type: 'triangle',
        radius: 7.5,
        symbolic: false,
        style: 'idle',
        rotation: 225,
        collision: {
            radius: 0.5,
        },
        onEnter() {
            if (this.style === 'active') audio.buffers.play('Flash_machine', {
                gain: 0,
            });
        }
    },
    {
        name: 'stonehenge-triangle-3',
        position: { x: 2, y: 0, z: 1.8 },
        color: 'hsl(90, 100%, 50%)',
        type: 'triangle',
        radius: 7.5,
        symbolic: false,
        style: 'idle',
        rotation: 270,
        collision: {
            radius: 0.5,
        },
        onEnter() {
            if (this.style === 'active') audio.buffers.play('Flash_Moskito', {
                gain: 0,
            });
        }
    },
    {
        name: 'stonehenge-triangle-4',
        position: { x: 1.41, y: 1.41, z: 1.8 },
        color: 'hsl(135, 100%, 50%)',
        type: 'triangle',
        radius: 7.5,
        symbolic: false,
        style: 'idle',
        rotation: 315,
        collision: {
            radius: 0.5,
        },
        onEnter() {
            if (this.style === 'active') audio.buffers.play('Flash_Hey', {
                gain: 0,
            });
        }
    },
    {
        name: 'stonehenge-triangle-5',
        position: { x: 0, y: 2, z: 1.8 },
        color: 'hsl(180, 100%, 50%)',
        type: 'triangle',
        radius: 7.5,
        symbolic: false,
        style: 'idle',
        rotation: 0,
        collision: {
            radius: 0.5,
        },
        onEnter() {
            if (this.style === 'active') audio.buffers.play('Flash_Inspir', {
                gain: 0,
            });
        }
    },
    {
        name: 'stonehenge-triangle-6',
        position: { x: -1.41, y: 1.41, z: 1.8 },
        color: 'hsl(225, 100%, 50%)',
        type: 'triangle',
        radius: 7.5,
        symbolic: false,
        style: 'idle',
        rotation: 45,
        collision: {
            radius: 0.5,
        },
        onEnter() {
            if (this.style === 'active') audio.buffers.play('Flash_chuchot', {
                gain: 0,
            });
        }
    },
    {
        name: 'stonehenge-triangle-7',
        position: { x: -2, y: 0, z: 1.8 },
        color: 'hsl(270, 100%, 50%)',
        type: 'triangle',
        radius: 7.5,
        symbolic: false,
        style: 'idle',
        rotation: 90,
        collision: {
            radius: 0.5,
        },
        onEnter() {
            if (this.style === 'active') audio.buffers.play('Flash_Melopee', {
                gain: 0,
            });
        }
    },
    {
        name: 'stonehenge-triangle-8',
        position: { x: -1.41, y: -1.41, z: 1.8 },
        color: 'hsl(315, 100%, 50%)',
        type: 'triangle',
        radius: 7.5,
        symbolic: false,
        style: 'idle',
        rotation: 135,
        collision: {
            radius: 0.5,
        },
        onEnter() {
            if (this.style === 'active') audio.buffers.play('Flash_grudge', {
                gain: 0,
            });
        }
    },
];

const sounds = [
    { name: 'ding', url: new URL('../../sound/DingCle.wav', import.meta.url) },
    { name: 'ding2', url: new URL('../../sound/DingCle2.wav', import.meta.url) },
    { name: 'Flash_chuchot', url: new URL('../../sound/Flash_chuchot.wav', import.meta.url) },
    { name: 'Flash_grudge', url: new URL('../../sound/Flash_grudge.wav', import.meta.url) },
    { name: 'Flash_Hey', url: new URL('../../sound/Flash_Hey.wav', import.meta.url) },
    { name: 'Flash_Inspir', url: new URL('../../sound/Flash_Inspir.wav', import.meta.url) },
    { name: 'Flash_machine', url: new URL('../../sound/Flash_machine.wav', import.meta.url) },
    { name: 'Flash_maraisOut', url: new URL('../../sound/Flash_MaraisOut.wav', import.meta.url) },
    { name: 'Flash_Melopee', url: new URL('../../sound/Flash_Melopee.wav', import.meta.url) },
    { name: 'Flash_Moskito', url: new URL('../../sound/Flash_Moskito.wav', import.meta.url) },
];

const images = [
    //{ name:'lake', url: 'images/lake.png' },
];

function init() {
    scene.addPOIs(POIs);
    //loader.addImages(images);
    loader.addSounds(sounds);
};
